module.exports = __webpack_public_path__ + "img/top-support-3.e2511fde.png";